export const FontFamilyStoreApp = {
  name: "Nunito",
  path: "https://fonts.googleapis.com/css?family=Nunito",
};
